/* eslint-disable no-undef */
// @flow

import * as React from 'react';
import {useEffect} from 'react';
import {useAccount} from 'docs/data';
import {isBrowser} from 'docs/util';
import {IntegrationCheckers} from 'docs/legacy/integrationCheckers/legacy';
import './IntegrationChecker.scss';

// This was all migrated over from site-srv as-is -- it could use a re-org now that it's in docs-renderer
const CHECKERS = {
  card: {
    name: 'accept_a_payment',
    redirectUrl: '/docs/payments/accept-a-payment#test-integration',
    integrationChecker: [
      'creates_payment_intent,creates_card_with_elements,confirms_payment_intent',
    ],
  },
  sepa: {
    name: 'sepa_debit_accept_a_payment',
    redirectUrl:
      '/docs/payments/sepa-debit/accept-a-payment#web-test-integration',
    integrationChecker: [],
  },
};

type IntegrationCheckerType = 'card' | 'sepa';

type IntegrationCheckerProps = {|
  type?: IntegrationCheckerType,
  children: React.Node,
|};

export const IntegrationChecker = ({
  type = 'card',
  children,
}: IntegrationCheckerProps) => {
  const {account} = useAccount();
  useEffect(() => {
    // The legacy app requires jQuery on the window
    // we can remove when we port over the app
    window.$ = $;
  }, []);

  if (!isBrowser || !window.$) {
    return null;
  }

  return (
    <IntegrationCheckers
      dashboardUrl="https://dashboard.stripe.com"
      currentMerchant={account.merchant?.token}
      siteUrl="https://stripe.com"
      redirectUrl={CHECKERS[type].redirectUrl}
      integrationChecker={CHECKERS[type].integrationChecker}
      inlineCheckersScenario="accept_a_payment_payment_succeeds_inline"
      integrationCheck={CHECKERS[type].name}
      inlineCheckers=""
    />
  );
};
